import { LoginResult } from "../Data/Internal/LoginResult";
import { accessToken, refreshToken } from "./LocalStorage";
import { get } from "svelte/store";
import { UserData } from "../Data/UserData";
import { PayslipData } from "../Data/PayslipData";
import { DocumentData } from "../Data/DocumentData";
import { QrScanResult } from "../Data/QrScanResult";
import { UnavailabilityData } from "../Data/UnavailabilityData";
const apiUrl = 'API_URL';
class HandApi {
    constructor() {
        // @ts-ignore
        this.mainUrl = apiUrl;
        this.basePath = this.mainUrl + "api/";
    }
    async login(username, password) {
        const loginUrl = this.basePath + "connect/token";
        let postData = new URLSearchParams({
            'grant_type': 'password',
            'client_id': 'handapp',
            'username': username,
            'password': password,
        });
        let fetchOpts = {
            method: 'POST',
            body: postData,
            //headers: {
            //    'Content-Type': 'application/x-www-form-urlencoded',
            //}
        };
        let response = await fetch(loginUrl, fetchOpts);
        let result = await response.json();
        if (!response.ok || result.hasOwnProperty('error')) {
            return new LoginResult({ success: false });
        }
        else {
            return new LoginResult({ success: true, accessToken: result['access_token'], refreshToken: result['refresh_token'] });
        }
    }
    async forgot(username) {
        let forgotUrl = this.basePath + "account/forgot?";
        let getData = new URLSearchParams({
            'email': username,
        });
        forgotUrl += getData;
        let response = await fetch(forgotUrl);
        let result = await response.json();
        return !(!response.ok || !result);
    }
    async userData() {
        const apiUrl = this.basePath + 'workerdata/summary';
        let fetchOpts = {
            headers: {
                'Authorization': 'Bearer ' + await this.getAccessToken()
            }
        };
        try {
            let response = await fetch(apiUrl, fetchOpts);
            if (response.status == 401) {
                await this.refreshAccessToken();
                fetchOpts.headers['Authorization'] = await this.getAccessToken();
                response = await fetch(apiUrl, fetchOpts);
            }
            let result = await response.json();
            return new UserData(result);
        }
        catch (_a) {
            return null;
        }
    }
    async availability() {
        const apiUrl = this.basePath + 'workerdata/availability';
        let fetchOpts = {
            headers: {
                'Authorization': 'Bearer ' + await this.getAccessToken()
            }
        };
        try {
            let response = await fetch(apiUrl, fetchOpts);
            if (response.status == 401) {
                await this.refreshAccessToken();
                fetchOpts.headers['Authorization'] = await this.getAccessToken();
                response = await fetch(apiUrl, fetchOpts);
            }
            let result = await response.json();
            let returnVals = [];
            for (let i = 0; i < result.length; i++) {
                returnVals.push(new UnavailabilityData(result[i]));
            }
            return returnVals;
        }
        catch (_a) {
            return null;
        }
    }
    async setUnavailability(from, to, reason, otherReason) {
        const apiUrl = this.basePath + "workerdata/unavailability";
        let postData = {
            dateFrom: from,
            dateTo: to,
            reason: reason,
            otherReason: otherReason,
        };
        let fetchOpts = {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
                'Authorization': 'Bearer ' + await this.getAccessToken(),
                'Content-Type': 'application/json',
            }
        };
        let response = await fetch(apiUrl, fetchOpts);
        if (response.status == 401) {
            let textResult = await response.text();
            await this.refreshAccessToken();
            fetchOpts.headers['Authorization'] = await this.getAccessToken();
            response = await fetch(apiUrl, fetchOpts);
        }
        let result = await response.json();
        return response.ok && result === true;
    }
    async removeUnavailability(id) {
        const apiUrl = this.basePath + "workerdata/remove-unavailability";
        let postData = {
            id
        };
        let fetchOpts = {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
                'Authorization': 'Bearer ' + await this.getAccessToken(),
                'Content-Type': 'application/json',
            }
        };
        let response = await fetch(apiUrl, fetchOpts);
        if (response.status == 401) {
            let textResult = await response.text();
            await this.refreshAccessToken();
            fetchOpts.headers['Authorization'] = await this.getAccessToken();
            response = await fetch(apiUrl, fetchOpts);
        }
        let result = await response.json();
        return response.ok && result === true;
    }
    async qrScan(qrCode, longitude, latitude, accuracy) {
        const apiUrl = this.basePath + "qrcode/scan";
        let postData = {
            qrData: qrCode,
            longitude: longitude,
            latitude: latitude,
            accuracy: accuracy,
            biometricsUsed: false
        };
        let fetchOpts = {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
                'Authorization': 'Bearer ' + await this.getAccessToken(),
                'Content-Type': 'application/json',
            }
        };
        let response = await fetch(apiUrl, fetchOpts);
        if (response.status == 401) {
            let textResult = await response.text();
            await this.refreshAccessToken();
            fetchOpts.headers['Authorization'] = await this.getAccessToken();
            response = await fetch(apiUrl, fetchOpts);
        }
        let result = await response.json();
        console.log(result);
        if (!response.ok) {
            return new QrScanResult({ isSuccess: false, message: 'Could not read from server.' });
        }
        else {
            return new QrScanResult(result);
        }
    }
    async getPayslipData() {
        const apiUrl = this.basePath + 'workerdata/payslips';
        let fetchOpts = {
            headers: {
                'Authorization': 'Bearer ' + await this.getAccessToken()
            }
        };
        try {
            let response = await fetch(apiUrl, fetchOpts);
            if (response.status == 401) {
                await this.refreshAccessToken();
                fetchOpts.headers['Authorization'] = await this.getAccessToken();
                response = await fetch(apiUrl, fetchOpts);
            }
            let result = await response.json();
            let returnVals = [];
            for (let i = 0; i < result.length; i++) {
                returnVals.push(new PayslipData(result[i]));
            }
            return returnVals;
        }
        catch (_a) {
            return null;
        }
    }
    async getDocumentData() {
        const apiUrl = this.basePath + 'workerdata/documents';
        let fetchOpts = {
            headers: {
                'Authorization': 'Bearer ' + await this.getAccessToken()
            }
        };
        try {
            let response = await fetch(apiUrl, fetchOpts);
            if (response.status == 401) {
                await this.refreshAccessToken();
                fetchOpts.headers['Authorization'] = await this.getAccessToken();
                response = await fetch(apiUrl, fetchOpts);
            }
            let result = await response.json();
            let returnVals = [];
            for (let i = 0; i < result.length; i++) {
                returnVals.push(new DocumentData(result[i]));
            }
            return returnVals;
        }
        catch (_a) {
            return null;
        }
    }
    async getAccessToken() {
        return get(accessToken);
    }
    async refreshAccessToken() {
        const loginUrl = this.basePath + "connect/token";
        let postData = new URLSearchParams({
            'grant_type': 'refresh_token',
            'client_id': 'handapp',
            'refresh_token': get(refreshToken),
        });
        let fetchOpts = {
            method: 'POST',
            body: postData,
        };
        let response = await fetch(loginUrl, fetchOpts);
        let result = await response.json();
        if (response.ok && !result.hasOwnProperty('error')) {
            refreshToken.set(result['refresh_token']);
            accessToken.set(result['access_token']);
        }
    }
}
export const handApi = new HandApi();
